/**
 * Chrome Translate wraps text nodes in <font>. React then calls removeChild /
 * insertBefore on the original node and throws NotFoundError, which takes down
 * the tree (leave hour-request form is a common hit).
 * https://github.com/facebook/react/issues/11538
 */
let installed = false;

export function patchChromeTranslateDom() {
  if (installed || typeof Node !== "function" || !Node.prototype) return;
  installed = true;

  const removeChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function patchedRemoveChild(child) {
    if (child && child.parentNode !== this) {
      return child;
    }
    return removeChild.apply(this, arguments);
  };

  const insertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function patchedInsertBefore(
    newNode,
    referenceNode
  ) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return insertBefore.apply(this, arguments);
  };
}
